import { createContext, useContext, useState, useMemo } from 'react';

const ConfigContext = createContext<any>(null);
export const useConfigContext = () => useContext(ConfigContext);

export const ConfigProvider: React.FC = ({ children }) => {
    const [selectedTimestamp, setSelectedTimestamp] = useState<string | null>(null);
    const [fftSelectedAxis, setFFTSelectedAxis] = useState<string | null>(null);
    const [fftSelectedParameter, setFFTSelectedParameter] = useState<string | null>(null);
    const [fftSelectedSensor, setFFTSelectedSensor] = useState<string | null>(null);

    const contextValue = useMemo(
        () => ({
            selectedTimestamp,
            fftSelectedAxis,
            fftSelectedParameter,
            fftSelectedSensor,
            setSelectedTimestamp,
            setFFTSelectedAxis,
            setFFTSelectedParameter,
            setFFTSelectedSensor,
        }),
        [fftSelectedAxis, fftSelectedParameter, fftSelectedSensor, selectedTimestamp]
    );

    return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
};
